export const sortAlphabeticallyByColumnKey = (columnKey) => (a, b) => {
  if (a[columnKey].toLowerCase() < b[columnKey].toLowerCase()) {
    return -1;
  } else {
    return 1;
  }
};
